var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgF1Group(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65 37.46V51h-9v-.51A10.5 10.5 0 0046.21 40a10.56 10.56 0 002-9h10.2A6.54 6.54 0 0165 37.46zM51 27a6.49 6.49 0 10.191-12.979A6.49 6.49 0 0051 27zm-5.48 17H30c-3.55 0-6 2.91-6 6.48V63h28V50.49A6.49 6.49 0 0045.52 44zM38 40a6.5 6.5 0 10-4.07-11.58A6.37 6.37 0 0032 31a6.49 6.49 0 006 9zM24.57 27a6.5 6.5 0 10-.012-13 6.5 6.5 0 00.012 13zm3.24 4H17.24A6.05 6.05 0 0011 37.45V51h9v-.52A10.16 10.16 0 0129.76 40a10.5 10.5 0 01-1.95-9z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/F1_Group.c060f311.svg";
export { SvgF1Group as ReactComponent };